<template lang="pug">
.audit-component
	v-e24-nav-bar(v-if="!printable")
	SectionTitle(:srcImage='imgHeader', :tall="tall", h1="Audit of the project :", :h2='project.name', v-if="!printable")
	SectionTitle(:srcImage='imgHeader', :tall="tall", h1="Project :", :h2='project.name', v-if="printable")

	vue-html2pdf(
		:show-layout="false"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1"
		pdf-content-width="800px"
        :filename="project.name"
        :pdf-quality="1"
        pdf-format="letter"
        pdf-orientation="portrait"

        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
		)
		section(slot="pdf-content" class="pdf-report" v-if="loaded")

			span
				span.report-tab(class="report-element") Project Information

				include ../project-report/information.pug

				//- h4.report-tab Contacts

				p
					contacts-block(:contacts="project.contacts", :isSecondToo="project.sgnrIsDcsnMkr")

			div(class="report-element")
				h4.report-tab Preferred Compliance Actions

				include ../project-report/compliance-actions.pug

			div(class="report-element")
				h4.report-tab Floors

				floors-roofs(v-if="canShow('floorsRoofs')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
				floors-roofs-addition(v-if="canShow('floorsRoofsAdd')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

			div(class="report-element")
				h4.report-tab Mechanical Systems

				mechanical-systems(v-if="canShow('mechSys')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
				mechanical-systems-addition(v-if="canShow('mechSysAdd')", :project="project", :control="control", :readonly="true" , :findControlTextByKey="findControlTextByKey")
				mechanical-systems-remodel(v-if="canShow('mechSysRem')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

			div(class="report-element")
				walls(v-if="canShow('walls')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
				walls-addition(v-if="canShow('wallsAdd')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

			div(class="report-element")
				glazing-in-existing(:project="project", :control="control", v-if='project.takeoff != 6 && project.takeoff != projType.newBuilding', :readonly="true", :findControlTextByKey="findControlTextByKey")
				glazing(:project="project", :control="control", :readonly="true", v-if="project.takeoff != projType.remodel", :findControlTextByKey="findControlTextByKey")

	section.maincolumn
		.app-page.project-audit-envelope
			.single.audit-wrap-content(v-if="loaded")

				.audit-container
					//- Success alert begin
					include success-btn
					//- Success alert end
					br

					//- error alert begin
					alert-component(v-if="auditErrors.length && !printable")
						.alert-area
							div(v-if="auditWarns.length > 0")
								p
									| An audit of your project generated {{ auditWarns.length }} warning(s). Please review the orange warnings below.
									| These warnings are a tool to alert you to potential errors, but they can be safely ignored.

							div(v-if="auditErrors.length > 0")
								p
									| An audit of your project has revealed {{ auditErrors.length }} error(s).
									br
									| Before you can submit your project for a report, you must correct the errors marked in red below.

							div(v-if="auditErrors.length > 0")
								| If you cannot get past this screen, please email us at Customer Service or call: (415) 259-4068

						.back-audit-button
							h4 Need to go back?
							router-link.btn-ui(to="/active-project") Back to editing this project
							br
							router-link.btn-ui(to="/project/list") Back to Project List
							br
					//- error alert end

					br
					span(class="report-first-module")
						h4.report-tab Project Information
						a( @click="generateReport") Download/Print
							img.loading-icon(v-if="progress > 10 && progress < 100 " :src="savingImage")
							img(:src="pdfIcon" v-else)

					include ../project-report/information.pug

					h4.report-tab Contacts
					br
					alert-component(v-if="(auditErrorsByTab('tab-compliance').length > 0 || auditWarnsByTab('tab-compliance').length > 0) && !printable")
						.alert-area
							div

								p
									| Contact validation errors:

								ul
									li.audit-error(v-for="error in auditErrorsByTab('tab-compliance')")
										| {{ error.text }}

								.got-to-tab
									router-link.arrow-audit(:to="{name: 'project.takeoff', params: { id: project.projId, tab: 'tab-compliance' }}") Go to that form

					br
					p
						contacts-block(:contacts="project.contacts", :isSecondToo="project.sgnrIsDcsnMkr")

					h4.report-tab Preferred Compliance Actions
					br(v-if="auditErrorsByTab('tab-actions').length > 0 || auditWarnsByTab('tab-actions').length > 0")

					alert-component(v-if="(auditErrorsByTab('tab-actions').length > 0 || auditWarnsByTab('tab-actions').length > 0) && !printable")
						.alert-area
							div

								p
									| Contact validation errors:

								ul
									li.audit-error(v-for="error in auditErrorsByTab('tab-actions')")
										| {{ error.text }}

								.got-to-tab
									router-link.arrow-audit(:to="{name: 'project.takeoff', params: { id: project.projId, tab: 'tab-compliance' }}") Go to that form

					include ../project-report/compliance-actions.pug

					h4.report-tab Floors
					br
					alert-component(v-if="(auditErrorsByTab('tab-floors').length > 0 || auditWarnsByTab('tab-floors').length > 0) && !printable")
						div.alert-area
							p
								| Floors validation errors:

							ul
								li.audit-error(v-for="error in auditErrorsByTab('tab-floors')")
									b Error:&nbsp;
									| {{ error.text }}

							ul(v-if="auditErrorsByTab('tab-floors').length <= 0")
								li.audit-warning(v-for="warning in auditWarnsByTab('tab-floors')")
									b Warning:
									| {{ warning.text }}

							.got-to-tab(v-if="auditErrorsByTab('tab-floors').length > 0 || auditWarnsByTab('tab-floors').length > 0")
								router-link.arrow-audit(:to="{name: 'project.takeoff', params: { id: project.projId, tab: 'tab-floors' }}") Go to that form

					floors-roofs(v-if="canShow('floorsRoofs')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
					floors-roofs-addition(v-if="canShow('floorsRoofsAdd')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

					// h4.report-tab(v-if="(auditErrorsByTab('tab-mech').length <= 0 || auditWarnsByTab('tab-mech').length <= 0) && !printable") Mechanical Systems
					h4.report-tab Mechanical Systems
					br(v-if="(auditErrorsByTab('tab-mech').length > 0 || auditWarnsByTab('tab-mech').length > 0) && !printable")
					alert-component(v-if="(auditErrorsByTab('tab-mech').length > 0 || auditWarnsByTab('tab-mech').length > 0) && !printable")
						div.alert-area
							p
								| Mechanical Systems validation errors:

							ul
								li.audit-error(v-for="error in auditErrorsByTab('tab-mech')")
									b Error:&nbsp;
									| {{ error.text }}

							ul(v-if="auditErrorsByTab('tab-mech').length <= 0")
								li.audit-warning(v-for="warning in auditWarnsByTab('tab-mech')")
									b Warning:
									| {{ warning.text }}

							.got-to-tab(v-if="auditErrorsByTab('tab-mech').length > 0 || auditWarnsByTab('tab-mech').length > 0")
								router-link.arrow-audit(:to="{name: 'project.takeoff', params: { id: project.projId, tab: 'tab-mechsystems' }}") Go to that form

					mechanical-systems(v-if="canShow('mechSys')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
					mechanical-systems-addition(v-if="canShow('mechSysAdd')", :project="project", :control="control", :readonly="true" , :findControlTextByKey="findControlTextByKey")
					mechanical-systems-remodel(v-if="canShow('mechSysRem')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

					walls(v-if="canShow('walls')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
					walls-addition(v-if="canShow('wallsAdd')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

					glazing-in-existing(:project="project", :control="control", v-if='project.takeoff != 6 && project.takeoff != projType.newBuilding', :readonly="true", :findControlTextByKey="findControlTextByKey")

					glazing(:project="project", :control="control", :readonly="true", v-if="project.takeoff != projType.remodel", :findControlTextByKey="findControlTextByKey")

					//- error alert begin
					alert-component(v-if="auditErrors.length && !printable")
						.alert-area
							div(v-if="auditWarns.length > 0")
								p
									| An audit of your project generated {{ auditWarns.length }} warning(s). Please review the orange warnings below.
									| These warnings are a tool to alert you to potential errors, but they can be safely ignored.

							div(v-if="auditErrors.length > 0")
								p
									| An audit of your project has revealed {{ auditErrors.length }} error(s).
									br
									| Before you can submit your project for a report, you must correct the errors marked in red above.

							div(v-if="auditErrors.length > 0")
								| If you cannot get past this screen, please email us at Customer Service or call: (415) 259-4068
					//- error alert end

					//- Success alert begin
					include success-btn
					//- Success alert end
					br
	v-e24-footer(v-if="!printable" :build="build")
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import MechanicalSystems from '../take-off-tool/tabs-components/mechanical-systems.vue'
import MechanicalSystemsAddition from '../take-off-tool/tabs-components/mechanical-systems-addition.vue'
import MechanicalSystemsRemodel from '../take-off-tool/tabs-components/mechanical-systems-remodel.vue'
import FloorsRoofs from '../take-off-tool/tabs-components/floors-roofs.vue'
import FloorsRoofsAddition from '../take-off-tool/tabs-components/floors-roofs-addition.vue'
import Walls from '../take-off-tool/tabs-components/walls-tab.vue'
import WallsAddition from '../take-off-tool/tabs-components/walls-tab-addition.vue'
import Glazing from '../take-off-tool/tabs-components/glazing.vue'
import GlazingInExisting from '../take-off-tool/tabs-components/glazing-in-existing.vue'
import SectionTitle from '@/common/components/sectionTitle.vue'
import imageHeader from '@/common/img/alpha-list-project.jpg'
import alertComponent from './alert-area.vue'
import easyBtn from 'Common/components/easy-btn.vue'
import PDFIcon from '@/common/img/pdficon.png'
import savingAnimation from '@/common/img/Spinner-1s-200px.svg'
import readBuild from '../../util/readBuild'

import VueHtml2pdf from 'vue-html2pdf'

export default {
	props: ['id', 'printable'],
	name: 'project-audit',
	components: {
		FloorsRoofs,
		FloorsRoofsAddition,
		MechanicalSystems,
		MechanicalSystemsAddition,
		MechanicalSystemsRemodel,
		Walls,
		WallsAddition,
		Glazing,
		GlazingInExisting,
		SectionTitle,
		alertComponent,
		easyBtn,
		VueHtml2pdf
	},
	data () {
		return {
			build: '',
			project: {},
			actionsNum: '',
			control: {},
			auditErrors: [],
			auditErrorsFlag: false,
			auditWarns: [],
			auditWarnsFlag: false,
			loaded: false,
			imgHeader: imageHeader,
			tall: 90,
			projType: {},
			pdfIcon: PDFIcon,
			contentRendered: false,
			progress: 0,
			pdfLoading: false,
			pdfDownloaded: false,
			savingImage: savingAnimation
		}
	},
	created () {
		this.projType = process.env.PROJTYPE
	},
	beforeMount: function () {
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	methods: {
		canShow (screenName) {
			let canShow = false
			switch (this.project.takeoff) {
			case process.env.PROJTYPE.newBuilding:
			case process.env.PROJTYPE.detachedAdd:
				canShow = (_.indexOf(['floorsRoofs', 'mechSys', 'walls', 'glazing', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.ePlusAdd:
			case process.env.PROJTYPE.conversion:
				canShow = (_.indexOf(['floorsRoofsAdd', 'mechSysAdd', 'wallsAdd', 'glazing', 'glazingExist', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.remodel:
				canShow = (_.indexOf(['floorsRoofs', 'mechSysRem', 'wallsAdd', 'compliance'], screenName) !== -1)
				break
			}
			return canShow
		},
		checkForErrors () {
			// make sure that a value was provided for Conditioned Floor Area
			console.log('checking errors', this.project)

			// Validating project floors tab
			this.validateFloor()

			// Validating project Mech sys tab
			this.validateMech()

			// Validating project Signer and Decision Maker contacts
			this.validateContacts()

			// Validating compliace actions
			this.validateComplianceActions()
		},
		auditErrorsByTab (tab) {
			return _.filter(this.auditErrors, {tab: tab})
		},
		auditWarnsByTab (tab) {
			return _.filter(this.auditWarns, {tab: tab})
		},
		findControlTextByKey (control, value) {
			if (control === 'prefCompl') console.log(' control ', this.control.prefCompl.text, ' value ', this.control.prefCompl.value)
			return Vue.e24.formService.findControlTextByKey(control, value, this.control)
		},
		validateFloor () {
			if (_.isNil(this.project.floorsRoofs.totalCondArea) || this.project.floorsRoofs.totalCondArea <= 0) {
				this.auditErrors.push({
					text: 'You must enter a positive value for the Conditioned Floor Area.',
					tab: 'tab-floors'
				})
				console.log('error totalCondArea', this.project)
			}
			if (_.isNil((this.project.floorsRoofs.totalAddition || this.project.floorsRoofs.totalAddition <= 3) && this.project.takeoff !== '8')) {
				this.auditErrors.push({
					text: 'Addition or Conversion is not of sufficient size. Floor Areas must be entered to total at least 4 square feet.',
					tab: 'tab-floors'
				})
				console.log('error totalCondArea', this.project)
			}
		},
		validateMech () {
			if (this.project.mechSystems.waterHeatSys === 'addNewKeepOld' && this.project.mechSystems.addNewAndKeep.number <= 0) {
				this.auditErrors.push({
					text: 'You must enter a positive value for the Number field.',
					tab: 'tab-mech'
				})
				// console.log('this.project.mechSystems.waterHeatSys', this.project.mechSystems.waterHeatSys)
			}
			if (this.project.mechSystems.waterHeatSys === 'addNewAndReplace' && this.project.mechSystems.addNewAndReplace.number <= 0) {
				this.auditErrors.push({
					text: 'You must enter a positive value for the Number field.',
					tab: 'tab-mech'
				})
				// console.log('this.project.mechSystems.waterHeatSys', this.project.mechSystems.waterHeatSys)
			}
		},
		validateComplianceActions () {
			let actionError = null
			let currentActions = 0
			let numberOfActions = this.project.isNewHome ? 4 : 6
			this.actionsNum = numberOfActions
			this.project.preference.compActions.map((act) => {
				currentActions++
				if (!act.action && currentActions <= numberOfActions) {
					// console.debug('Validating ' + act.action)
					actionError = true
				}
			})
			if (actionError) {
				this.auditErrors.push({
					text: `You must enter at least ${numberOfActions} valid compliance actions and their priorities`,
					tab: 'tab-actions'
				})
			}

			if (this.project.preference.HERS.provider === 'Cheers.org') {
				if (_.isNil(this.project.preference.HERS.ownerName) || this.project.preference.HERS.ownerName === '') {
					this.auditErrors.push({
						text: `You must enter a valid owner name, CalEnergy insists on entering Owner's information before a project/site can be registered`,
						tab: 'tab-actions'
					})
				}
				if (_.isNil(this.project.preference.HERS.ownerPhone) || this.project.preference.HERS.ownerPhone === '') {
					this.auditErrors.push({
						text: `You must enter a valid owner phone, CalEnergy insists on entering Owner's information before a project/site can be registered`,
						tab: 'tab-actions'
					})
				}
				if (_.isNil(this.project.preference.HERS.ownerEmail) || this.project.preference.HERS.ownerEmail === '') {
					this.auditErrors.push({
						text: `You must enter a valid owner email, CalEnergy insists on entering Owner's information before a project/site can be registered`,
						tab: 'tab-actions'
					})
				}
			}
		},
		validateContacts () {
			// TODO: move contacts validations to common validation service
			let count = 0
			this.project.contacts.map((prjContact) => {
				const contact = prjContact.object
				console.log('Validating ' + prjContact.title + ' ' + contact)
				// console.debug('this.project.contacts RC', this.project.contacts[0].object.emailAddress().address)
				// console.debug('prjContact.object.name.first ', prjContact.object.name.first)
				// If Decision Maker checkbox is false
				if (!this.project.sgnrIsDcsnMkr) {
					if (!contact.name.first || !contact.name.last) {
						this.auditErrors.push({
							text: `You must enter ${prjContact.title} contact first name and last name`,
							tab: 'tab-compliance'
						})
					}
					if (!contact.emailAddress().address ||
						!Vue.jnx.validationService.isEmail.test(contact.emailAddress().address)) {
						this.auditErrors.push({
							text: `You must enter ${prjContact.title} email address`,
							tab: 'tab-compliance'
						})
					}
				// If Decision Maker checkbox is true
				} else if (this.project.sgnrIsDcsnMkr && count <= 0) {
					if (!this.project.contacts[0].object.name.first || !this.project.contacts[0].object.name.last) {
						this.auditErrors.push({
							text: `You must enter Report Signer contact first name and last name`,
							tab: 'tab-compliance'
						})
					}
					if (!this.project.contacts[0].object.emailAddress().address ||
						!Vue.jnx.validationService.isEmail.test(contact.emailAddress().address)) {
						this.auditErrors.push({
							text: `You must enter Report Signer email address`,
							tab: 'tab-compliance'
						})
					}
					count++
				}
				//	!contact.postalAddress().line1 ||
				//	!contact.postalAddress().cityText ||
				//	!contact.postalAddress().stateText ||
				//	!contact.postalAddress().postalCode
			})
		},
		generateReport () {
			this.$refs.html2Pdf.generatePdf()
		},
		onProgress (progress) {
			this.progress = progress
			console.log(`PDF generation progress: ${progress}%`)
		},

		hasStartedGeneration () {
			// console.log(`PDF has started generation`)
		},

		hasGenerated (blobPdf) {
			// this.pdfDownloaded = true
			// console.log(`PDF has downloaded`)
			// console.log(blobPdf)
		},

		domRendered () {
			console.log('Dom Has Rendered')
			this.contentRendered = true
			this.pdfLoading = false
		},

		onBlobGenerate (blob) {
			// console.log('blob ', blob)
		}
	},
	beforeRouteEnter: (to, from, next) => {
		let project
		Vue.e24.projectService.findOneById(to.params.id).then((projectLoaded) => {
			project = projectLoaded
			return Vue.e24.formService.findControlByForm(['info', 'mech', 'walls', 'glazing_existing', 'glazing', 'floor_attic', 'prefs'])
		}).then((control) => {
			next((vm) => {
				console.log('Auditing project', project)
				console.log('Control', control)

				// Loading project
				vm.project = project
				vm.control = control
				vm.loaded = true
				vm.checkForErrors()
			})
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/app/project-audit/project-audit.vue